import { useQuery } from "convex/react";

import { api } from "@convex/_generated/api";

/**
 * Live subscription for a single task's detail page (`/tasks/$taskId`).
 * Wraps `tasks.getById` — ownership, surface separation, and hidden-state
 * checks are all server-side; a miss of ANY kind arrives as `null`
 * (rendered as not-found). `undefined` = snapshot not yet loaded.
 */
export function useTask(taskId: string) {
  const task = useQuery(api.tasks.getById, { taskId });
  return {
    task: task ?? null,
    isLoading: task === undefined,
  };
}
